export default __webpack_public_path__ + "static/media/user_group.d5d28e13.svg";